import Card from "./Card/Card";

import styles from "./CardImageGrid.module.css";

function CardImageGrid({
	items,
	imageStyles,
	type,
	highlight,
	hasSections = false,
}) {
	return (
		<>
			{!hasSections && (
				<section className={styles.cardGrid}>
					{items.map((item, i) => {
						if (item.show) {
							return (
								<Card
									key={`${type}-card-${i}`}
									image={item.image}
									imageStyles={imageStyles}
									description={item.desc}
									disabled={item.disabled}
								/>
							);
						}
						return <></>;
					})}
				</section>
			)}

			{hasSections &&
				Object.keys(items).map((key, i) => {
					return (
						<>
							<div
								className={styles.programType}
								key={`${key}-${i}-label`}
							>
								{key}
							</div>
							<section
								className={styles.cardGrid}
								key={`${key}-${i}-section`}
							>
								{items[key].map((item, i) => {
									if (item.show) {
										return (
											<Card
												key={`${type}-section-${i}`}
												image={item.image}
												imageStyles={imageStyles}
												description={item.desc}
												disabled={item.disabled}
											/>
										);
									}
									return <></>;
								})}
							</section>
						</>
					);
				})}

			{highlight && highlight.length > 0 && (
				<div className={styles.highlightContainer}>
					<div className={styles.highlightBody}>Destaque:</div>
					<div className={styles.highlightBody}>
						{highlight.join(", ")}
					</div>
				</div>
			)}
		</>
	);
}

export default CardImageGrid;
